export const AnnouncementBar = () => null;
